import React, { Fragment, useState, useContext } from "react";
import styled from "styled-components";
import { Context } from "../../../../context/globalContext";
import { ThemeProps } from "../../../genericComponents/globalStyles";
import Work from "./Work";
import Research from "./Research";
import Volunteer from "./Volunteer";
import School from "./School";
import Letter from "./Letter";
import { ADD_USER_SUBCOLLECTION, DELETE_USER_SUBCOLLECTION, EDIT_USER_SUBCOLLECTION } from "../../../../helpers/graphqlMutations";
const arrayWork = ["work", "research", "volunteer", "school", "letter"];

export default function Experiences() {
  const {
    graphQLClient,
    state: {
      user: userProfile,
      userWorks,
      userResearchs,
      userVolunteers,
      userSchools,
      userLetters,
    },
    dispatch: {
      setUserWorwks,
      setUserVolunteers,
      setUserSchools,
      setUserResearchs,
      setUserLetters,
    },
  } = useContext(Context);

  const [stateWork, setStateWork] = useState(arrayWork[0]);

  // -------------------addUserSubcollection-------------------------
  function addUserSubcollection(subcollection) {
    return new Promise((resolve, reject) => {
      graphQLClient
        .mutate({
          variables: { ...subcollection, email: userProfile.email },
          mutation: ADD_USER_SUBCOLLECTION,
        })
        .then((result) => resolve(result))
        .catch((err) => reject(err));
    });
  }
  function addWorkExperience(workExperience) {
    addUserSubcollection(workExperience).then((r) => {
      const id = r?.data?.addUserSubCollection?.id;
      workExperience.id = id;
      setUserWorwks([workExperience, ...userWorks]);
    });
  }
  function addResearch(research) {
    addUserSubcollection(research).then((r) => {
      const id = r?.data?.addUserSubCollection?.id;
      research.id = id;
      setUserResearchs([research, ...userResearchs]);
    });
  }
  function addVolunteer(volunteer) {
    addUserSubcollection(volunteer).then((r) => {
      const id = r?.data?.addUserSubCollection?.id;
      volunteer.id = id;
      setUserVolunteers([volunteer, ...userVolunteers]);
    });
  }
  function addSchool(school) {
    addUserSubcollection(school).then((r) => {
      const id = r?.data?.addUserSubCollection?.id;
      school.id = id;
      setUserSchools([school, ...userSchools]);
    });
  }
  function addNewLetter(letter) {
    addUserSubcollection(letter).then((r) => {
      const id = r?.data?.addUserSubCollection?.id;
      letter.id = id;
      setUserLetters([letter, ...userLetters]);
    });
  }
  // ----------------------editUserSubcollection-----------------------------
  function editUserSubcollection(subcollection) {
    return new Promise((resolve, reject) => {
      graphQLClient
        .mutate({
          variables: { ...subcollection, email: userProfile.email },
          mutation: EDIT_USER_SUBCOLLECTION,
        })
        .then((result) => resolve(result))
        .catch((err) => reject(err));
    });
  }
  function editWorkExperience(workExperience) {
    editUserSubcollection(workExperience).then((r) => {
      const newUserWork = userWorks.slice();
      const index = newUserWork.findIndex((i) => i.id === workExperience.id);
      newUserWork.splice(index, 1, workExperience);
      setUserWorwks(newUserWork);
    });
  }
  function editResearch(research) {
    editUserSubcollection(research).then((r) => {
      const newUserResearch = userResearchs.slice();
      const index = newUserResearch.findIndex((i) => i.id === research.id);
      newUserResearch.splice(index, 1, research);
      setUserResearchs(newUserResearch);
    });
  }
  function editVolunteer(volunteer) {
    editUserSubcollection(volunteer).then((r) => {
      const newUserVolunteer = userVolunteers.slice();
      const index = newUserVolunteer.findIndex((i) => i.id === volunteer.id);
      newUserVolunteer.splice(index, 1, volunteer);
      setUserVolunteers(newUserVolunteer);
    });
  }
  function editSchool(school) {
    editUserSubcollection(school).then((r) => {
      const newUserSchool = userSchools.slice();
      const index = newUserSchool.findIndex((i) => i.id === school.id);
      newUserSchool.splice(index, 1, school);
      setUserSchools(newUserSchool);
    });
  }
  function editLetter(letter) {
    editUserSubcollection(letter).then((r) => {
      const newUserLetter = userLetters.slice();
      const index = newUserLetter.findIndex((i) => i.id === letter.id);
      newUserLetter.splice(index, 1, letter);
      setUserLetters(newUserLetter);
    });
  }
  // ---------------------deleteUserSubcollection------------------------------
  function deleteUserSubcollection(subcollection) {
    return new Promise((resolve, reject) => {
      graphQLClient
        .mutate({
          variables: { ...subcollection, email: userProfile.email },
          mutation: DELETE_USER_SUBCOLLECTION,
        })
        .then((result) => resolve(subcollection.subcollectionId))
        .catch((err) => reject(err));
    });
  }
  function deleteWorkExperience(workExperience) {
    deleteUserSubcollection(workExperience).then((id) => {
      const newUserWork = userWorks.filter((r) => r.id !== id);
      setUserWorwks(newUserWork);
    });
  }
  function deleteResearch(research) {
    deleteUserSubcollection(research).then((id) => {
      const newUserResearch = userResearchs.filter((r) => r.id !== id);
      setUserResearchs(newUserResearch);
    });
  }
  function deleteVolunteer(volunteer) {
    deleteUserSubcollection(volunteer).then((id) => {
      const newUserVolunteer = userVolunteers.filter((r) => r.id !== id);
      setUserVolunteers(newUserVolunteer);
    });
  }
  function deleteSchool(school) {
    deleteUserSubcollection(school).then((id) => {
      const newUserSchools = userSchools.filter((r) => r.id !== id);
      setUserSchools(newUserSchools);
    });
  }
  function deleteLetter(letter) {
    deleteUserSubcollection(letter).then((id) => {
      const newUserLetters = userLetters.filter((r) => r.id !== id);
      setUserLetters(newUserLetters);
    });
  }

  const renderCVWithCondition = () => {
    switch (stateWork) {
      case arrayWork[0]:
        return (
          <Work
            userProfile={userProfile}
            workExperiences={userWorks || []}
            editWorkExperience={editWorkExperience}
            addNewWorkExperience={addWorkExperience}
            deleteWorkExperience={deleteWorkExperience}
          />
        );
      case arrayWork[1]:
        return (
          <Research
            researches={userResearchs || []}
            userProfile={userProfile}
            addNewResearch={addResearch}
            editResearch={editResearch}
            deleteResearch={deleteResearch}
          />
        );
      case arrayWork[2]:
        return (
          <Volunteer
            volunteers={userVolunteers || []}
            addNewVolunteer={addVolunteer}
            editVolunteer={editVolunteer}
            deleteVolunteer={deleteVolunteer}
          />
        );
      case arrayWork[3]:
        return (
          <School
            schools={userSchools}
            addNewSchool={addSchool}
            editSchool={editSchool}
            deleteSchool={deleteSchool}
          />
        );
      case arrayWork[4]:
        return (
          <Letter
            userProfile={userProfile}
            letters={userLetters}
            addNewLetter={addNewLetter}
            editLetter={editLetter}
            deleteLetter={deleteLetter}
          />
        );
      default:
        break;
    }
  };

  return (
    <Fragment>
      <section style={{ marginTop: 80, marginBottom: 80 }}>
        <ExperienceTitle>Experiences</ExperienceTitle>
        <TowRowContainer>
          <RowOne>
            <ItemButton
              active={stateWork === arrayWork[0]}
              onClick={() => setStateWork(arrayWork[0])}
            >
              Work
            </ItemButton>
            <ItemButton
              active={stateWork === arrayWork[1]}
              onClick={() => setStateWork(arrayWork[1])}
            >
              Research
            </ItemButton>
            <ItemButton
              active={stateWork === arrayWork[2]}
              onClick={() => setStateWork(arrayWork[2])}
            >
              Volunteering
            </ItemButton>
            <ItemButton
              active={stateWork === arrayWork[3]}
              onClick={() => setStateWork(arrayWork[3])}
            >
              Schools
            </ItemButton>
            {/* <ItemButton
              active={stateWork === arrayWork[4]}
              onClick={() => setStateWork(arrayWork[4])}
            >
              Letters
            </ItemButton> */}
          </RowOne>
          <RowTwo>
            {renderCVWithCondition()}
          </RowTwo>
        </TowRowContainer>
      </section>

    </Fragment>
  );
}

const ExperienceTitle = styled.p`
  font-size: 2.4em;
  margin-bottom: 12px;
  font-weight: bold;
`;
const TowRowContainer = styled.div`
  display: flex;
`;
const RowOne = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 80px;
`;
const RowTwo = styled.div`
  padding-left: 40px;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 550px;
  border-left: 1px solid ${ThemeProps.color.gabaYellow};
`;
const ItemButton = styled.button`
  margin: 4px 0;
  padding: 4px 16px;
  text-align: left;
  font-size: 1.3em;
  background: none;
  outline: none;
  border: none;
  color: ${(p) => (p.active ? ThemeProps.color.darkGreen : null)};
`;